export enum outreach {
  ROY_TG_LINK = `https://t.me/funkyfounder`,
}
